import styled from "styled-components";

export const PricingWrapper = styled("div")(() => {
  return {
    borderRadius: "1rem",
    backgroundColor: "var(--color-background)",
    display: "grid",
    gap: "1.5rem",
    "& .heading": {
      margin: 0,
      "& h3": {
        marginBlock: 0,
        fontFamily: "Poppins",
        fontWeight: 700,
        fontSize: "1.2rem",
        color: "var(--color-text)",
        letterSpacing: "0.02em",
        textTransform: "uppercase",
      },
    },
    "& .plans-and-pricing-table": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.9rem",
      overflowX: "auto",
      backgroundColor: "var(--color-neutral)",
    },
    "& .plans-and-pricing-table table": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      minWidth: "950px",
    },
    "& th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },
    "& td": {
      order: "none",
      borderBottom: "1px solid #edf1f6",
      color: "var(--color-text)",
      padding: "0.95rem 1rem",
      minWidth: "unset",
      fontSize: "0.88rem",
      verticalAlign: "middle",
      position: "relative",
    },
    "& td:first-of-type": {
      borderLeft: "none",
    },
    "& .plans-and-pricing-table td:last-child": {
      color: "var(--color-text)",
      "&:hover": {
        color: "var(--color-primary)",
        textDecoration: "underline",
        cursor: "pointer",
      },
    },
    "& .plans-and-pricing-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#FFFFFF",
      borderRadius: "1rem",
      boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
      "@media screen and (max-width: 768px)": {
        bottom: "0",
        right: "0",
        borderRadius: "1rem",
        top: "50%",
        left: "50%",
        height: "auto",
        transform: "translate(-50%, -50%)",
      },
      "@media screen and (max-width: 425px)": {
        width: "85%",
        padding: "var(--cardPadding) calc(var(--cardPadding)/2)",
      },
    },
  };
});
